module.exports = __webpack_public_path__ + "img/javascript.90b53354.png";